import React from 'react'
import { Solution } from 'util/constants'
import PostCommentsTabs from 'components/Posts/display/PostCommentsTabs'

interface Props {
  solution: Solution
}

const SolutionProfileTabs = ({ solution }: Props) => {
  return (
    <PostCommentsTabs kind="solution" entityId={solution.id} entityTitle={solution.title} />
  )
}

export default SolutionProfileTabs
